export default __webpack_public_path__ + "static/media/building-small.9994de31.webp";